<h1 mat-dialog-title>
  <ng-container i18n="Contest Direct URL Modal|Contest Direct URL Modal title@@contest-direct-url-modal-title">
    Exam Direct URL
  </ng-container>
</h1>
<div mat-dialog-content #dialogContent class="full-width details-content">
  <p i18n="Contest Direct URL Modal|Contest Direct URL details@@contest-direct-url-details">
    Below you can see the direct contest exam URL. It can be shared with participants and used to take part on exam day.
  </p>
  <p *ngIf="contest && contest.name">{{contest.name}}</p>
  <p class="mat-body-strong contest-url">
    <span class="url-content word-wrap">{{getExamUrl}}</span>
    <span class="url-action">
      <mat-icon class="copy-btn"
                (click)="copyMessage(getExamUrl);"
                matTooltip="Copy"
                i18n-matTooltip="General|Copy action label@@general-copy-action-label"
                color="primary">save
      </mat-icon>
    </span>
  </p>
</div>
<div mat-dialog-actions>
  <app-button [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Close"
              i18n-label="General|Close action label@@general-close-action-label"></app-button>
</div>
